import { DARK_MODE_EVENT_NAME } from "storybook-dark-mode"

const routes = {
  ROOT: "/",
  auth: {
    LOGIN: "login",
    RESET_PASSWORD: "forgot-password",
  },
  DASHBOARD: "dashboard",
  CHATS: "chats",
  APPOINTMENTS: "appointments",
  CAB_BOOKINGS: "cab-bookings",
  PATIENTS: "patients",
  SERVICES: "services",
  DOCTORS: "doctors",
  USER_MANAGEMENT: "user-management",
}

export default routes
